import { Component, OnInit } from '@angular/core';
import { UserManagementService } from '../../../shared/services/user-management.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { AuthService } from '../../../shared/services/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-data-ingestion',
  templateUrl: './data-ingestion.component.html',
  styleUrl: './data-ingestion.component.scss',
})
export class DataIngestionComponent implements OnInit {
  readonly viewDataIngestion = ['app.dcr-portal.s3-data-transfer.view'];

  constructor(
    private userManagementService: UserManagementService,
    private nzMessageService: NzMessageService,
    private authService: AuthService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    const bucketName = this.userManagementService.getBucketName();

    if (this.authService.hasEntitlements(this.viewDataIngestion) && !bucketName) {
      this.nzMessageService.error('Bucket is not assigned to your account. Contact DCR admin to complete setup.');
      this.router.navigate(['./']);
    }
  }
}
